import React from 'react';
import type { DashboardSurfaceSectionProps } from './DashboardSurfaceSection.types';

export type { DashboardSurfaceSectionProps } from './DashboardSurfaceSection.types';

export const DashboardSurfaceSection: React.FC<DashboardSurfaceSectionProps> = ({
    theme,
    initialDashboardReady,
    isDashboardOpen,
    layoutVariant = 'v2',
    children,
}) => {
    const layoutClass = [
        'editor-dashboard-inner',
        'obd-dashboard-container',
        'obd-dashboard-v3',
        'obd-dashboard-bento',
        'obd-dashboard-glass',
        `obd-theme-${theme}`,
        'obd-dashboard-surface-v2',
        'obd-dashboard-surface-layout',
        layoutVariant === 'v3' ? 'obd-dashboard-ui-v3' : 'obd-dashboard-ui-v2',
        initialDashboardReady && isDashboardOpen ? 'obd-dashboard-surface-layout--bottom-safe' : '',
    ]
        .filter(Boolean)
        .join(' ');

    return <div className={layoutClass}>{children}</div>;
};
